// Represents the timestamp for December 31, 9999, 00:00:00 UTC, used to indicate a permanent block.
export const PERMANENT_BLOCK_UNTIL_TIMESTAMP = 253402214400000;
